export const TOUR_LOCAL_STORAGE_KEY = 'getting-started-tour';

export enum TourActions {
  initialize = 'initialize',
  start = 'start',
  next = 'next',
  back = 'back',
  complete = 'complete',
}
